import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SimpleConfigBaseFilter } from 'gung-list';
import { Product } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class ProductMerchandiseTypeFilterService extends SimpleConfigBaseFilter<Product> {
  constructor(private translateService: TranslateService) {
    super();
  }
  getName(): string {
    return 'MERCHANDISE_TYPE';
  }
  getOptionIds(item: Product): string[] {
    return item.extra.i18n[this.translateService.currentLang].ItemMerchandiseType_Value || [];
  }
  getOptionName(key: string): string {
    return key;
  }
}
